import { ButtonType, ButtonWidget, TabStyles } from '@tableau/widgets';
import * as React from 'react';
import { ButtonWithUberDialog } from '~src/common/react/components/ButtonWithUberDialog';
import { DataQualityTriggerConfigurationUIAction, DataQualityTriggerConfigurationUI } from './DataQualityTriggerDialog';
import { imgPath } from '~src/common/utilities/ImgUrl';
import { Messages } from '~src/codegen/Localize';

export type DataQualityTriggerUberDialogProps = {
  readonly dispatch: React.Dispatch<DataQualityTriggerConfigurationUIAction>;
  readonly enableTrigger: boolean;
  readonly isSevere: boolean;
  readonly message: string;
}

export function DataQualityTriggerUberDialog(props: DataQualityTriggerUberDialogProps): JSX.Element {
  const buttonProps = {
    testId: 'LinkedTaskUberDQW',
    buttonType: ButtonType.Icon,
    title: Messages.dataQualityTriggerDialog_Title_Flow(),
    style: {
      padding: `${TabStyles.Spacing.SmallSpace}px`,
      marginLeft: `${TabStyles.Spacing.SmallSpace}px`,
    }
  };
    return(
      <ButtonWithUberDialog
        dialogWidth={500}
        renderButton={showDialog => (
            <ButtonWidget {...buttonProps} onClick={showDialog} >
              <img src={imgPath('menu_edit.svg')} alt={Messages.dataQualityDialog_Title()} />
            </ButtonWidget>
        )}
        uberDialogContent={
          <DataQualityTriggerConfigurationUI
            contentType={'flow'}
            enableTrigger={props.enableTrigger}
            isSevere={props.isSevere}
            message={props.message}
            dispatch={props.dispatch}
          />
        }
      />
    );
  }




